import { PlatformDependencies } from '@citrite/workspace-ui-platform';
import { container } from 'Workspace/DependencyManagement';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

export const maximumResourceCountForSimpleView = 20;

export const isSimpleView = (resources?: Resource[]): boolean => {
	return (
		resources?.length <= maximumResourceCountForSimpleView &&
		!isSimpleViewDisabled(resources)
	);
};

const isSimpleViewDisabled = (resources: Resource[]) => {
	return resources?.length > 0 && isSimpleViewDisabledInCloudConsole();
};

export const isSimpleViewDisabledInCloudConsole = (): boolean => {
	const workspaceConfiguration = container
		.resolve(PlatformDependencies.WorkspaceConfiguration)
		.get();
	return workspaceConfiguration?.userInterface?.enableSimpleView === 'false';
};
